<template>
  <builderall-loader :loading="loadingAll" class="ba-w-100">
    <div class="card-body ba-w-100">
      <div class="ba-flex ba-jc-fe ba-gp-1">
        <form v-if="items && items.length > 0 && items.find(x => !x.name == false)">
          <div class='ba-box-search-input'>
              <input type='search' class='ba-input' v-model="filtro" :placeholder="$t('ct-search')" />
              <button class='ba-button'>
                  <builderall-icon code='search' />
              </button>
          </div>
        </form>
        <button type="button" class="ba-btn ba-blue ba-md" @click="newObj">
          <i class="svg-icon svgi-add-circle mr-3"></i
          >{{ $t(`ct-create-new-${title.toLowerCase()}`) }}
        </button>
      </div>
      <section v-if="filterItems && filterItems.length > 0 && filterItems.find(x => !x.name == false)">
        <div v-if="type === 'Popup'" class="exit-popup__total-views">
          <span>{{ $t('ct-popup-list-total-impressions') }}: {{ popupViewsTotal }}</span>
          <builderall-icon code="help" ba-tooltip-position="left"
                          :ba-tooltip-title="$t('ct-popup-list-total-impressions-tooltip').replace('%impressions_limit%', popupViewsLimit)"></builderall-icon>
        </div>
        <table class='ba-table ba-md ba-w-100 ba-lines-all'>
            <thead>
                <tr>
                    <th class="ba-w-50">{{ $t('ct-name') }}</th>
                    <th class="ba-w-50"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!iten.name == false" v-for="(iten, index) of filterItems" :key="index">
                    <td>
                      <span class="py-1 d-block popup__name">
                        {{ iten.name.length > 55 ? iten.name.substring(0, 55) + "..." : iten.name }}
                      </span>
                      <template v-if="iten.external_host && iten.external_path">
                        <div class="exit-popup">
                          <div class="exit-popup__url">
                            <span>https://{{ iten.external_host }}{{ iten.external_path }}</span>
                            <builderall-icon code="b54c"
                                            @click="copyToClipboard(`https://${iten.external_host}${iten.external_path}`)"
                                            ba-tooltip-position="left" :ba-tooltip-title="$t('ct-copy')"
                            />
                          </div>
                          <span class="py-1 d-block" v-if="type === 'Popup'">
                          <span class="exit-popup__views">{{ $t('ct-popup-list-item-total-impressions') }}: {{ popupViews[iten.id] || 0 }}</span>
                        </span>
                        </div>
                      </template>
                    </td>
                    <td>
                      <div class="ba-flex ba-gp-04 ba-jc-fe ba-ai-center">
                        <router-link
                          v-if="objects_list === 'multiaction'"
                          :to="{
                            name: 'MultiActionEdit',
                            params: { action_id: iten.action_id },
                          }"
                          class="btn btn-default px-0"
                          target="_blank"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <router-link
                          v-else-if="objects_list === 'powerup'"
                          :to="{
                            name: 'editor-layout-item',
                            params: {
                              id_item: iten.encrypted_id,
                              type: objects_list,
                              website_id: website_id,
                            },
                          }"
                          class="btn btn-default px-0"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <router-link
                          v-else
                          :to="{
                            name: 'editor-layout-item',
                            params: {
                              id_item: iten.encrypted_id,
                              type: objects_list,
                              website_id: website_id,
                            },
                          }"
                          target="_blank"
                          class="btn btn-default px-0"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <button
                          v-if="type === 'Popup'"
                          class='ba-btn ba-btn-normal ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="'Configurations'"
                          @click.prevent="configuration(iten)"
                          >
                            <builderall-icon code="5270"/>
                        </button>
                        <button
                          class='ba-btn ba-btn-normal ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="$t('ct-duplicate')"
                          @click.prevent="duplicate(iten)"
                          >
                            <builderall-icon code='b54c' />
                        </button>
                        <button
                          class='ba-btn ba-btn-trash ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="$t('ct-exclude')"
                          @click.prevent="openConfirmDelete(iten)"
                          >
                            <builderall-icon code='trash' />
                        </button>
                      </div>
                      <div v-if="(objects_list === 'multiaction') & (iten.id !== 0)">
                        <div class="mr-2">
                          <p>{{ iten.total_counter }}</p>
                          <p>{{ $t(`ct-clicks`) }}</p>
                        </div>
                        <div class="mr-2">
                          <p>{{ iten.partial_counter }}</p>
                          <p>{{ $t(`ct-click-interval`) }}</p>
                        </div>
                      </div>
                    </td>
                </tr>
            </tbody>
        </table>
      </section>

      <!-- Create -->
      <sweet-modal ref="create-template" hide-close-button @close="cleanCreateElement">
        <div class="create-template-popup ba-grid ba-gp-04">
          <div class='ba-flex ba-jc-sb ba-gp-1'>
              <span class='ba-title'>{{ $t('ct-new') }} {{ title }}</span>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePopup">
                  <builderall-icon code='64f7' />
              </button>
          </div>
          <hr class='ba-hr-row'>
          <div class='ba-content'>
            <div class='ba-box-input'>
              <div class='ba-info'>
                  <label class='ba-label'>{{ $t('ct-name') }}</label>
              </div>
              <input
                type='text'
                maxlength="50"
                class='ba-input'
                v-model="item.name"
                :placeholder="$t('ct-text-go-here')"
              />
            </div>
            <br>
            <div class="ba-flex ba-jc-fe ba-gp-1">
              <button class="ba7-btn-transparent" @click="closePopup">{{ $t('ct-cancel') }}</button>
              <button
                class="ba7-btn-save ba-btn ba-blue ba-md"
                :disabled="!item.name"
                @click="create()"
              >
                {{ $t('ct-save') }}
              </button>
            </div>
          </div>
        </div>
      </sweet-modal>

      <!-- DELETE -->
      <modal-delete-component
        :show="modalDelete.show"
        :text="modalDelete.text"
        :description="modalDelete.description"
        :values="modalDelete.config"
        @cancel="cancelConfirmDelete"
        @exclude="exclude"
      ></modal-delete-component>

      <modal-create-popup-component ref="modalCreatePopup" :isBundle="isBundle" @save="createPopup($event)"/>

      <sweet-modal ref="modalPublicationPopup" icon="success">
        {{ $t('ct-your-changes-saved') }}
      </sweet-modal>
    </div>
  </builderall-loader>
</template>

<script>
import ModalDeleteComponent from "../../components/ModalDelete";
import ModalCreatePopupComponent from "../../components/ModalCreatePopup.vue";
import {
  create as createHeader,
  update as updateHeader,
  destroy as deleteHeader,
} from "../../../../js/services/editor/headers";
import {
  create as createFooter,
  update as updateFooter,
  destroy as deleteFooter,
} from "../../../../js/services/editor/footers";
import {
  create as createPopup,
  update as updatePopup,
  destroy as deletePopup,
} from "../../../../js/services/editor/popups";
import {
  create as createPowerup,
  update as updatePowerup,
  destroy as deletePowerup,
} from "../../../../js/services/editor/powerups";
import {
  get as getMultiaction,
  create as createMultiaction,
  update as updateMultiaction,
  destroy as deleteMultiaction,
} from "../../../../js/services/editor/multiactions";
import { get } from "../../../../js/services/editor/layout";
import { SweetModal } from "sweet-modal-vue";

import Errors from "./../../../../js/base/Errors";
import Collapse from "../../components/Collapse.vue";
import {updateVersion} from "../../../../js/services/editor/publish";
import Http from "../../../../js/services/http";

export default {
  name: "Feaders",
  props: ["type", "title", "isBundle"],
  components: { SweetModal, ModalDeleteComponent, ModalCreatePopupComponent, Collapse },
  data() {
    return {
      errors: new Errors(),
      items: [],
      website_id: null,
      item: {
        name: "",
        layout_id: null
      },
      modalDelete: {
        show: false,
        config: "",
      },
      layout_id: null,
      getItems: null,
      createItem: null,
      updateItem: null,
      deleteItem: null,
      objects_list: null,
      filtro: "",
      loadingAll: false,
      popupViews: {},
      popupViewsTotal: 0,
      popupViewsLimit: Number(10000).toLocaleString()
    };
  },
  watch: {
    type: async function () {
      await this.init();
      await this.updateList();
    },
  },
  methods: {
    init() {
      switch (this.type) {
        case "Header": {
          this.createItem = createHeader;
          this.updateItem = updateHeader;
          this.deleteItem = deleteHeader;
          this.objects_list = "header";
          break;
        }

        case "Footer": {
          this.createItem = createFooter;
          this.updateItem = updateFooter;
          this.deleteItem = deleteFooter;
          this.objects_list = "footer";
          break;
        }

        case "Popup": {
          this.createItem = createPopup;
          this.updateItem = updatePopup;
          this.deleteItem = deletePopup;
          this.objects_list = "popup";
          break;
        }

        case "Powerup": {
          this.createItem = createPowerup;
          this.updateItem = updatePowerup;
          this.deleteItem = deletePowerup;
          this.objects_list = "powerup";
          break;
        }

        case "Multiaction": {
          this.getItems = getMultiaction;
          this.createItem = createMultiaction;
          this.updateItem = updateMultiaction;
          this.deleteItem = deleteMultiaction;
          this.objects_list = "multiaction";
          break;
        }
      }
      this.filtro = "";
    },

    newObj() {
      if (this.type === "Popup") {
        this.empty();
        this.$refs.modalCreatePopup.open();
        return;
      } else {
        this.$refs["create-template"].open();
      }

      if (this.items.length) {
        if (this.items[0].id === 0) {
          return null;
        }
      }

      this.items.unshift({
        id: 0,
        name: "",
      });
    },

    closePopup(){
      this.$refs["create-template"].close();
      this.cleanCreateElement();
    },

    cleanCreateElement(){
      this.item.name = "";
      this.typeToCreate = null;
      // this.items.shift();
    },

    create(copy = false) {
      if (copy) {
        console.log(copy)
        this.item = copy;
        this.item.name += " - copy";
        this.item.encrypted_id = null;
      } else {
        this.item.content = undefined;
      }
      if (this.type === "Multiaction") {
        this.item.website_id = this.$route.params.id;
      }
      if (!this.item.encrypted_id) {
        this.item.layout_id = this.layout_id;
      }
      if (!this.validate()) {
        this.loadingAll = true;
        const editing = this.item.encrypted_id;
        (editing ? this.updateItem : this.createItem)(this.item)
          .then((res) => {
            if(res.data.success){
              this.closePopup();
              this.$snotify.success(this.$t("ct-saved-successfully"));
              this.updateList();
              if (this.type === "Popup") {
                updateVersion(this.website_id);
                if (editing) {
                  this.$refs.modalPublicationPopup.open();
                } else {
                  const routeData = this.$router.resolve({
                    name: "editor-layout-item",
                    params: {
                      type: this.objects_list,
                      id_item: res.data.data.encrypted_id,
                      website_id: this.$route.params.id,
                    },
                  });
                  window.open(routeData.href, '_blank');
                }
              }
            } else {
              this.$snotify.error(this.$t(`ct-item-name-required`));
            }
          })
          .finally(() => {
            this.loadingAll = false;
          });
        this.empty();
      } else {
        this.$snotify.error(this.$t(`ct-item-name-required`));
      }
    },

    createPopup(item) {
      this.item = this.item ? {...this.item, ...item} : item;
      this.create();
    },

    validate() {
      this.errors = new Errors();
      if (!this.item.name && !(this.item.name.length > 0)) {
        this.errors.add("name", "validation-required", "item");
      }

      return this.errors.any();
    },

    updateList() {
      this.$loading.show();

      if (this.type === "Multiaction") {
        this.getItems(this.$route.params.id)
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => this.$loading.hide());
      } else {
        get(this.layout_id)
          .then((response) => {
            this.items = response.data[this.objects_list + "s"];
            this.website_id = response.data.website.encrypted_id;
          })
          .finally(() => this.$loading.hide());
        if (this.type === "Popup") {
          Http.authApi()
            .get(`/external-popup/${this.layout_id}/views`)
            .then(response => {
              this.popupViews = response.data || {};
              this.popupViewsTotal = Object.values(this.popupViews)
                .reduce((total, views) => total + views, 0);
            });
        }
      }
    },

    empty() {
      this.item = {
        name: "",
        layout_id: this.layout_id,
      };
      this.errors.clear();
    },

    exclude(item) {
      this.$loading.show();
      this.deleteItem(item)
        .then((res) => {
          this.modalDelete.show = false;
          this.modalDelete.config = "";
          this.updateList();
        })
        .finally(() => this.$loading.hide());
    },

    openConfirmDelete(config) {
      this.modalDelete.show = true;
      this.modalDelete.config = config;
    },

    cancelConfirmDelete() {
      this.modalDelete.show = false;
      this.modalDelete.config = "";
    },

    duplicate(item) {
      this.$loading.show();
      if (this.type === "Multiaction") {
        item.website_id = this.$route.params.id;
      }
      this.create(item);
    },

    configuration(item) {
      this.item = item;
      this.$refs.modalCreatePopup.open(item);
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
  },
  async created() {
    this.loadingAll = true;
    this.layout_id = this.$route.params.layout_id;

    await this.init();
    await this.updateList();
    this.loadingAll = false;
  },
  computed: {
    filterItems() {
      return this.items.filter((item) => {
        return item.name.match(this.filtro);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  header form {
    position: relative;
    height: 47px;
    margin-right: 20px;

    i {
      position: absolute;
      left: 20px;
      top: 15px;
    }

    input {
      height: -webkit-fill-available;
      padding-left: 45px;
    }
  }

  section {
    .group-tags-desc {
      color: #5a5959;
      font-size: 16px;
      margin-left: 0.25rem;
    }

    .card-tags-group {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: end;

      .card-header {
        font-size: 18px;
        color: #0080fc;
        font-weight: 700;
        border: none !important;
        flex: 1;
        overflow-x: hidden;

        span {
          overflow-wrap: normal;
          overflow-x: hidden;
          white-space: nowrap;
        }
      }

      form input {
        border: none;
        background: transparent;
      }

      .card-body {
        text-align: right;
        padding: 0.75rem;
        flex: none;
        border: none;

        button:after {
          display: none;
        }
      }

      &.p-3 {
        color: #5a5959;
        font: Muli;
        font-size: 13px;
        font-weight: 600;

        p {
          margin: 0;

          &:last-child {
            color: #908d8d;
            font-size: 12px;
            font-style: italic;
          }
        }
      }
  }

  .sombra {
    box-shadow: 0 0 0 100vw #59607175;
    z-index: 2;
  }

  .btn-grey {
    background: #fcfcfc;
    padding: 25px 0 !important;
    font-weight: 600 !important;
  }

  > div > .col-12.text-center {
    color: #5a748b;
    font-size: 20px;
    font-family: "Muli";
  }
}

.create-template-popup{
  label{
    margin-bottom: 0;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    color: #111827;
  }
  .ba-title{
    color: #0072E1;
    font-family: Montserrat;
    font-size: 22px;
    font-weight: 600;
    line-height: 24.2px;
  }
  .ba-btn-close{
    builderall-icon{
      --builderall-icon-size: 22px;
    }
  }
  .ba-content{
    margin-top: 16px;
  }
  .ba7-btn-transparent{
    background: transparent;
    border: none;
    outline: none;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    color: #4D5D71;
  }
  .ba7-btn-save{
    width: 150px;
  }
}
button{
  outline: none;
}
.builderall-icon-edit {
  height: 20px;
  width: 20px;
  --builderall-icon-color: #0380fc;

  builderall-icon {
    transform: scale(1.35);
  }
}

.card-popup {
  display: flex;
  flex-direction: column !important;

  .card-header, .card-body, .card-popup-url {
    width: 100%;
  }

  .card-header {
    padding-bottom: 0;
  }

  .card-popup-url {
    display: flex;
    padding: 0 1.25rem;

    span {
      flex: 1;
      overflow: hidden;
      color: #54779E;
      text-overflow: ellipsis;
      font-family: Montserrat, sans-serif;
      font-size: 14px;
      font-weight: 500;
    }

    builderall-icon {
      width: 18px;
      height: 18px;
      --builderall-icon-color: #425E7D;
      cursor: pointer;

      &:hover {
        --builderall-icon-color: #0380fc;
      }
    }
  }

  .card-body {
    display: block !important;
  }
}

.popup__name {
  color: #4D5D71;
  font-size: 13px;
  font-weight: 700;
}

.exit-popup {
  .exit-popup__url {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #54779E;
    font-size: 14px;

    builderall-icon {
      width: 18px;
      height: 18px;
      --builderall-icon-color: #0380fc;
      cursor: pointer;
    }
  }

  .exit-popup__views {
    color: #4D5D71;
    font-size: 13px;
    font-weight: 700;
  }
}

.exit-popup__total-views {
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: #4D5D71;
    font-size: 13px;
    font-weight: 700;
  }

  builderall-icon {
    width: 22px;
    height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/items/FootersHeadersPopups.vue